import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Col } from "react-bootstrap";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { getFileInformation } from "../../utils/base64Conver";
import { PostSignFileService } from "../../Services/signFileService";
import Spinner from 'react-bootstrap/Spinner';


const PopUpSignFilesManage = ({ show, handleClose, reloadData, company }) => {
  const [t] = useTranslation("companies")

  const [error, setError] = useState(false)
  const [type, setType] = useState(null)
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [enabledButton, setEnabledButton] = useState(false)
  const [loading, setLoading] = useState(false)




  const handleFileInput = async (e) => {
    const fileData = e.target.files[0];

    if (!fileData) {
      setFileError(`${t("signFiles.fileError")}`);
      return;
    }

    const maxSize = 2 * 1024 * 1024; // 2 MB
    const valid_mimetypes = [
      'application/pdf'
    ];


    if (fileData.size > maxSize) {
      setFileError(`${t("signFiles.fileSizeError")}`);
      setFile(null);
      return;
    }


    if (!valid_mimetypes.includes(fileData.type)) {
      setFileError(`${t("signFiles.fileTypeError")} .pdf`);
      setFile(null);
      return;
    }

    const fileConvert = await getFileInformation(fileData);

    setFile(fileConvert);
    setFileError(null);
    setEnabledButton(true)
  };

  const handleClick = async () => {
    setLoading(true)
    let isValid = true;
    if (!type) {
      setTypeError(`${t("signFiles.typeError")}`);
      isValid = false;
      setEnabledButton(false)
    } else {
      setTypeError(null);
      setEnabledButton(true)
    }
    if (!file) {
      setFileError(`${t("signFiles.fileError")}`);
      isValid = false;
      setEnabledButton(false)
    } else {
      setFileError(null);
      setEnabledButton(true)
    }

    if (isValid) {
      var postData = {
        company: company,
        mimeType: file.mimeType,
        fileName: file.fileName,
        fileData: file.base64Content,
        type: type,
      }
      const response = await PostSignFileService(postData);
      handleClose();
      reloadData()
    }

    setLoading(false)

  }


  const handleChangeType = (value) => {
    setTypeError(null);
    setType(value);
    setEnabledButton(true)
  }


  const handleCloseResetStates = () => {
    handleClose();
    setEnabledButton(false)
  }

  const removeFile = () => {
    setFile(null);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2">{t("signFiles.create")}</p>
                <div className="text-center mt-auto w-100">
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleCloseResetStates}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <Col md={12}>
                    <FormCard
                      title={t("signFiles.type")}
                      type={"select"}
                      options={[
                        { label: `${t("signFiles.responsibleStart")}`, value: "Acreditación de responsable" },
                        { label: `${t("signFiles.responsibleFinish")}`, value: "Acreditación cese de responsable" },
                      ]}
                      error={typeError}
                      errorMessage={t("signFiles.typeError")}
                      readOnly={false}
                      onChange={(e) => {
                        handleChangeType(e.value)
                      }}
                      centered
                    />
                  </Col>
                  <Col md={9} className="mt-4 mx-auto">
                    {file && (
                      <div className="mb-4 add-doc custom-shadow">
                        {" "}
                        {/* Añadido estilo para alinear a la izquierda */}
                        <span>{file.fileName}</span>
                        <FaTimes className="add-doc-icon" onClick={removeFile} />
                      </div>
                    )}
                    {fileError && (
                      <span className="form-card-input-error-text m-auto text-center">{fileError}</span>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      onChange={handleFileInput}
                    />
                    <label htmlFor="fileInput">
                      <Button variant="secondary" className="custom-button-secondary" as="span">
                        {t("signFiles.addDoc")}
                      </Button>
                    </label>
                  </Col>
                  <Button
                    type="submit"
                    className=" mx-auto mt-4 custom-button-primary custom-bg-primary"
                    onClick={handleClick}
                    disabled={!enabledButton || loading}
                  >
                    {loading ?

                      <>
                        <Spinner animation="border" className="spinner me-4" />
                        {t("signFiles.saving")}
                      </>
                      :
                      <>
                        {t("signFiles.save")}
                      </>
                    }


                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpSignFilesManage;